import { $t } from "@/plugins/i18n";
import { sendJSON } from "@/utils/common";
export default [
  {
    path: "/",
    redirect: "/index",
    meta: {
      title: $t("shell.menus.home"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("../../views/index/index.vue"),
    meta: {
      title: $t("shell.menus.home"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../../views/login/index.vue"),
    meta: {
      title: $t("shell.menus.login"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/channel-select",
    name: "ChannelSelect",
    component: () => import("../../views/login/channelSelect.vue"),
    meta: {
      title: $t("shell.menus.login"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("../../views/demo.vue"),
    meta: {
      title: "demo",
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/external/callback/jcb",
    meta: {
      title: $t("shared.auth.creditCard.promotions"),
      requireLogin: true,
      showLink: false,
      rank: 101
    },
    redirect: to => {
      // const ua = navigator.userAgent;
      // const isAndroid = ua.match(/(Android)\s+([\d.]+)/);
      // const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      // const isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
      // const isMobile = isIphone || isAndroid;
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile =
        /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(
          userAgent
        );
      if (isMobile) {
        return "/credit-card-match/jcb-guide";
        // sendJSON({
        //   type: "VIEW_NAVIGATE",
        //   payload: {
        //     page: "AccountJoin",
        //     params: { tab: "promotions", ...to?.query }
        //   }
        // });
      } else {
        return "/credit-card-match";
      }
    }
  },
  {
    path: "/credit-card-match",
    name: "CreditCardMatch",
    component: () => import("../../views/creditCard/index.vue"),
    meta: {
      title: $t("shared.auth.creditCard.promotions"),
      showLink: false,
      requireLogin: true,
      rank: 101
    }
  },
  {
    path: "/credit-card-match/jcb-guide",
    name: "CreditCardMatchJcbGuide",
    component: () => import("../../views/creditCard/jcbGuide.vue"),
    meta: {
      title: "JCBプレミアム、ワンランク上の滞在を",
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/credit-card-match/verifyJcb",
    name: "VerifyJcb",
    component: () => import("../../views/creditCard/verifyJcb.vue"),
    meta: {
      title: $t("shared.auth.creditCard.promotions"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/airline-match",
    name: "AirlineMatch",
    component: () => import("../../views/airlineMatch/index.vue"),
    meta: {
      title: $t("shared.contactInfo.airlineMatch.title"),
      showLink: false,
      rank: 101
    }
  }
];
